import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["ribbon", "observationView", "linkToObservation", "graphIcon"];
  static values = { observationView: { type: String, default: "ribbon" } };

  toggle({ detail: { content } }) {
    const isExpanding = content;
    const gridTemplateRows = isExpanding ? "1fr" : "0fr";

    this.ribbonTarget.style.gridTemplateRows = gridTemplateRows;
  }

  changeView() {
    this.observationViewTargets.forEach(el => el.classList.toggle("hidden"));
    this.observationViewValue = (this.observationViewValue === "ribbon") ? "chart" : "ribbon";
    this.updateLink();
    this.updateGraphIconStyling();
  }

  updateLink() {
    const url = new URL(this.linkToObservationTarget.href);
    url.searchParams.set("observation_view", this.observationViewValue);
    this.linkToObservationTarget.href = url.href;
  }

  updateGraphIconStyling() {
    [
      "border-indicators-purple-primary",
      "bg-indicators-purple-secondary",
      "border-action-border",
      "hover:border-indicators-purple-primary",
      "hover:bg-indicators-purple-secondary",
      "hover:border-action-border",
      "hover:bg-transparent"
    ].forEach(className => this.graphIconTarget.classList.toggle(className));
  }
}
